import { useRef, useState } from 'react'
import styles from '../reportSection.module.scss';
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, Grid, Typography } from '@mui/material'
import { CommonButton, CommonOutlinedButton, CustomDownIcon, CustomLeftIcon, CustomUpIcon } from '../../common/StyledComponents/StyledFields';


import { PoojaReportBySignInNameProps } from '../../../infrastructure/GlobalContextProvider';
import { ReportToRender } from "../../common/RenderSubReports";
import PriestReportsTableData from './PriestReportsTableData';
import ButtonLoader from '../../common/ButtonLoader/ButtonLoader';
import { useReactToPrint } from 'react-to-print';
import { apiRequest } from '../../../infrastructure/backendService';
import apiPath from "../../../config/apiPaths.json";


const PriestReports = ({ subReports }: any) => {

  const [dataFromChild, setDataFromChild] = useState(false);
  const [poojaReportData, setPoojaReportData] = useState<PoojaReportBySignInNameProps[]>([]);
  const [columnData, setColumnData] = useState({});
  const [subReportsAccordiansArray, setSubReportsAccordians] = useState(new Array(2).fill(false));
  const [subReportsName, setSubReportsName] = useState("");
  const [loading, setLoading] = useState(false);
  const [priestReportsReqBody,setPriestReportsReqBody] = useState<any>()
  const [formData,setFormData] = useState<any>()

  function handleDataFromChild(data: any,reqBody:any, formDataPriestsBookingReport:any) {
    setDataFromChild(data);
    setPriestReportsReqBody(reqBody)
    setFormData(formDataPriestsBookingReport)
  }

  function handleGoingBackToMainReportsSection() {
    setDataFromChild(false);
  }

  function getReportData(data: any) {
    if(subReportsName === "Priest's Schedule Summary - Consolidated" && data.length === 0){
      setPoojaReportData([]);
      return;
    }
    let columnHeaders = data[0];
    let columns: any = {};
    for (let key of Object.keys(columnHeaders)) {
      columns[key] = key;
    }
    setPoojaReportData(data);
    setColumnData(columns);
  }

  const [expandedPanel, setExpandedPanel] = useState(null);

  const handleToggleChange = (index: any) => {
    setExpandedPanel(expandedPanel === index ? null : index);
    const accordianArray = [...subReportsAccordiansArray];
    accordianArray[index] = !accordianArray[index];
    setSubReportsAccordians(accordianArray);
    const reportObj = subReports.subMenus.find(
      (report: any, i: number) => i === index
    );
    setSubReportsName(reportObj.title);
  };
  const displayReportName = () => {
    switch (subReportsName) {
      case "Priest's Schedule Summary - Consolidated":
        return `${priestReportsReqBody.occuranceType} Priest's Schedule Summary - Consolidated
        (${priestReportsReqBody.params.selectedMonth} ${priestReportsReqBody.params.monthRange} ${priestReportsReqBody.params.selectedYear})`
      case "Priest Booking Report":
        return `${"Priest Booking Report"} ${formData.poojaDateFrom} to  ${formData.poojaDateTo}`
      default:
        break;
    }
  }

  const printStyles = `
  @media print {
    /* Set paper size to Tabloid (11x17 inches) */
    @page {
      size: tabloid;
      margin: 24px;
    }
  
    /* Set layout to Landscape */
    body {
      width: 100vw;
      position: absolute;
      // top: 10%;
      left: 100;
    }
  
    /* Add more styles as needed for printing */
  }
  
`;

  const PrintRef = useRef<any>(null);
  const handlePrint = useReactToPrint({
    content: () => PrintRef.current,
    pageStyle:printStyles,
   
  });

  const ExportToExcel = async () => {
    try {
      let endpoint = "";
      let method:any = "";
      let reqBody = null;
      let params = null;
  
      switch (subReportsName) {
        case "Priest's Schedule Summary - Consolidated":
          endpoint = `${apiPath.priestScheduleReports}/${priestReportsReqBody.occuranceType}/excel`;
          method = "GET";
          params = priestReportsReqBody.params;
          break;
        case "Priest Booking Report":
          endpoint = "/report-dashboard/reports/priest/PRIEST_BOOKING_REPORT/excel";
          method = "POST";
          reqBody = priestReportsReqBody;
          break;
        default:
          console.error("Invalid subReportsName");
          return;
      }
  
      setLoading(true);
      if (endpoint) {
        const response = await apiRequest({
          method: method,
          endpoint: endpoint,
          ...(method === "POST" ? { body: JSON.stringify(reqBody) } : { params: params }),
          includeToken: true,
          responseType: 'arraybuffer'
        });
  
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.download = `${subReportsName}.xlsx`;
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid subReportsName");
      }
    } catch (error) {
      setLoading(false);
      console.error('Error downloading Excel file:', error);
    }
  };
  
  
  return (
    <>
      {!dataFromChild ? (
        <div className={styles.poojareportsLayout}>
          <Typography className={styles.typoGraphyHeader}>
            Priest Reports
          </Typography>
          <Card className={styles.cardContainer}>
            <Grid container columnSpacing={"12px"} rowSpacing={"10px"}>
            {subReports &&
              subReports.subMenus.map((report: any, index: any) => (
                <Grid
                    item
                    xs={12}
                    md={expandedPanel === index ? 12 : 6}
                    key={index}
                  >
                <Accordion
                  sx={{
                    border: subReportsAccordiansArray[index] ? '1px solid #F05802' : '1px solid #989898',
                    background: '#FFF9E4',
                    boxShadow: "none", 
                    borderRadius: "8px",
                    ".MuiAccordionSummary-content.Mui-expanded": {
                      my: "12px"
                    },
                    ".MuiAccordionSummary-root.Mui-expanded": {
                      minHeight: "auto"
                    },
                  }}
                  expanded={expandedPanel === index}
                  onChange={() => handleToggleChange(index)}
                >
                  <AccordionSummary
                    aria-controls={`panel-content`}
                    id={`panel--header`}
                  >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Box className={styles.iconstyles}>
                          {expandedPanel === index ? (
                            <CustomUpIcon />
                          ) : (
                            <CustomDownIcon />
                          )}
                        </Box>
                        <Typography
                          className={"sub_heading"}
                          style={{fontWeight: `${expandedPanel === index ? "bold": "500"}`, fontSize: "16px"}}
                        >
                          {report.title}
                        </Typography>
                      </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{p: "0px 16px 16px 16px"}}>
                    {ReportToRender(report.key, handleDataFromChild, getReportData)}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
            </Grid>
          </Card>
        </div>
      ) : (
        <div ref={PrintRef}>
          <Box >
            <Typography
              sx={{
                fontFamily: "Lato",
                fontSize: "20px",
                fontWeight: 500,
                color: "#882E14",
                display: "flex",
                gap: "10px",
              }}
            >
              <span
                style={{ margin: "4px 0" }}
                onClick={handleGoingBackToMainReportsSection}
                className="no_print"
              >
                <CustomLeftIcon />
              </span>
              <span>
                {displayReportName()}
              </span>
              <Box 
              sx={{
                display: "flex",
                gap: "16px",
                marginLeft: "auto",
                float: "right",
                marginBottom:"16px"
              }}
              className = "no_print"
            >
              <CommonOutlinedButton onClick={handlePrint} className="no_print" disabled={poojaReportData.length === 0}>
                Print
              </CommonOutlinedButton>
              <CommonButton
                style={{ whiteSpace: "nowrap" }}
                onClick={ExportToExcel}
                disabled={loading || poojaReportData.length === 0}
                className="no_print"
              >
                <ButtonLoader
                  isBtnLoading={loading}
                  btnText={"Export To Excel"}
                />
              </CommonButton>
            </Box>
            </Typography>
          </Box>
          <PriestReportsTableData tableHeaders={columnData} ReportData={poojaReportData} />
        </div>

      )}
    </>
  )
}

export default PriestReports